import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../shared/services/authentication.service';
import Swal from 'sweetalert2';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  lang = localStorage.getItem('language') || 'en';
  subscriptions: Subscription[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry({ count: 4, delay: 10000 }),
      catchError(err => {
        if (err.status === 425) {
          this.authenticationService.logout();
        }
        if (this.authenticationService.currentUserValue) {
          if (err.status === 424 || err.status === 423 || err.status === 403) {
            // this.authenticationService.logout();
            this.router.navigate(['/notAuthorized']);
            setTimeout(() => { Swal.close() }, 100);
          }
          if (err.status === 401 || err.status === 422) {
            if (!this.subscriptions.length) {
              this.subscriptions.push(
                this.authenticationService.RefeshUserToken().subscribe(data => {
                  this.subscriptions = [];
                }, err => {
                  this.authenticationService.logout();
                  this.subscriptions = [];
                })
              );
            }
          }
        }
        if (err.status === 0) { // Offline
          this.snackBar.open(
            this.lang == 'en' ? 'You are offline!' : 'أنت غير متصل!',
            this.lang == 'en' ? 'Ok' : 'حسنا',
            {
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
          // this.snackBar.open(this.translate.instant('general.You are offline!'), this.translate.instant('swalMsg.Ok'), {
          //   horizontalPosition: 'center',
          //   verticalPosition: 'top'
          // });
        }

        // const error = err.error.message || err.statusText;
        return throwError(err.error);
      })
    );
  }
}
